import { ref as s, watch as F } from "vue";
const N = (o, C, {
  onInput: c,
  onValidityChange: v
}) => {
  const l = s(!1), t = s(!1), i = s(!1), r = s(!1), u = s(!1), d = s(0), f = () => {
    var a, n;
    if (!l.value)
      return;
    const e = t.value;
    t.value = o.value ? !((n = (a = o.value) == null ? void 0 : a.validity) != null && n.valid) : !1, e !== t.value && v && v(!t.value);
  };
  return F(C, () => {
    r.value = !0, f();
  }), {
    listeners: {
      blur: () => {
        l.value = r.value, f(), t.value || (l.value = !1), i.value = !1;
      },
      compositionend: (e) => {
        u.value && c(e), u.value = !1;
      },
      compositionstart: () => {
        u.value = !0;
      },
      focus: () => {
        i.value = !0;
      },
      input: (e) => {
        var a, n, p, m, T, g, x;
        if (((a = o.value) == null ? void 0 : a.type) === "number") {
          const E = e.inputType === "insertText" || e.inputType === "insertFromPaste", h = e.data === "." && d.value === ((p = (n = o.value) == null ? void 0 : n.value) == null ? void 0 : p.length), D = e.data === ",", I = e.inputType === "deleteContentBackward", y = (T = (m = o.value) == null ? void 0 : m.value) == null ? void 0 : T.lastIndexOf("."), k = ((x = (g = o.value) == null ? void 0 : g.value) == null ? void 0 : x.length) ?? 0, B = y !== -1 && y === k - 1;
          if (E && (h || D) || I && B)
            return;
        }
        u.value || c(e);
      },
      mouseup: () => {
        var e;
        d.value = ((e = o.value) == null ? void 0 : e.selectionEnd) || 0;
      }
    },
    touched: l,
    invalid: t,
    focused: i
  };
};
export {
  N as useNativeInput
};
